import '../styles/feature-links.scss'
import type { FC } from 'react'
import { Link } from 'react-router-dom'
import { cmsDataService } from '@/common/services/cms.data.service'

export const FeatureLinks: FC = () => {
    const featureLinks = cmsDataService.get().footer.featureLinks.featureLinks

    return (
        <ul className="footer-feature-links">
            {featureLinks.map((featureLink, index) => (
                <li key={index}>
                    <Link to={featureLink.url} target={featureLink.target}>
                        {featureLink.name}
                    </Link>
                </li>
            ))}
        </ul>
    )
}
